(function(){
  "use strict";
  function initSweepFloor(root){
    if (!root || root.dataset.sfReady === '1') return;
    root.dataset.sfReady = '1';
  (function(){
    "use strict";
    var ASSETS = { vac: root.dataset.vac, blow: root.dataset.blow };
    var BG = root.dataset.bg || '#0E3868';
    // Each render is a different attachment, so each carries its own nozzle-tip
    // anchor (fraction of sprite height at the left edge) and on-screen width.
    // Sized as a fraction of the court height, not a fixed width: at a short
    // court a fixed sprite buries its own body through the floor line.
    var SPRITE = {
      vac:  { tipF: (parseFloat(root.dataset.tipvac)||12.16)/100, hf: 0.22, min: 104, max: 270 },
      blow: { tipF: (parseFloat(root.dataset.tipblow)||11.7)/100, hf: 0.30, min:  64, max: 168 }
    };
    var band    = root.querySelector('.ottr-sf-court');
    var court   = root.querySelector('.ottr-sf-court');
    court.setAttribute('tabindex','-1');
    function claimKeys(){
      try{ window.focus(); court.focus({preventScroll:true}); }catch(e){}
    }
    court.addEventListener('pointerenter', claimKeys);
    court.addEventListener('pointerdown', claimKeys);
    var canvas  = root.querySelector('[data-sf="stage"]');
    var ctx     = canvas.getContext('2d', { alpha:false });
    var rpmEl   = root.querySelector('[data-sf="rpm"]');
    var powerEl = root.querySelector('[data-sf="power"]');
    var debrisEl= root.querySelector('[data-sf="debrisName"]');
    var battEl  = root.querySelector('[data-sf="batt"]');
    var battFillEl = root.querySelector('[data-sf="battFill"]');
    var sndEl   = root.querySelector('[data-sf="snd"]');
    var SND_ON  = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M15.5 9a4 4 0 0 1 0 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M18 6.5a7.5 7.5 0 0 1 0 11" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    var SND_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MAX_RPM = 130000;
    /* ---------------- surfaces ---------------- */
    var SCENES = {
      dust: {
        name:'Dust', g:0.06, bounce:0.02, n:700, kind:'dot', r:[1.2,3.1], drag:0.87,
        colors:['#C9CFD6','#9AA4AF','#E6EBF0','#7D8892']
      },
      crumbs: {
        name:'Crumbs', g:0.34, bounce:0.32, n:480, kind:'chunk', r:[2.2,5.0], drag:0.80,
        colors:['#C79A62','#E0C08B','#A87B45','#D9B073','#8E6636']
      },
      grit: {
        name:'Grit', g:0.48, bounce:0.12, n:640, kind:'dot', r:[1.3,3.0], drag:0.83,
        colors:['#C8BFAE','#9C917E','#E0D6C4','#7E7466']
      },
      fur: {
        name:'Fur', g:0.05, bounce:0.0, n:300, kind:'strand', r:[1.2,2.1], drag:0.88,
        colors:['#D8D2C6','#B0A899','#EFEBE2','#8C8377']
      }
    };
    var sceneKey=(root.dataset.scene && SCENES[root.dataset.scene]) ? root.dataset.scene : 'crumbs';
    var mode='vac';
    // Picking a mess should say what it is while the stuff is still in the air —
    // the icons are legible as a set, not one at a time.
    var nameT=0;
    function announce(){
      if (!debrisEl) return;
      debrisEl.textContent = SCENES[sceneKey].name;
      band.classList.add('is-naming');
      if (nameT) clearTimeout(nameT);
      nameT = setTimeout(function(){ band.classList.remove('is-naming'); nameT=0; }, 2000);
    }
    /* ---------------- state ---------------- */
    var W=0,H=0,DPR=1;
    var parts=[], queue=[], collected=0, armed=false, emit=0;
    var powerTarget=0.65, powerNow=0;
    var batt=1, flat=false;
    var motorOn=true, lastPower=0.65;   // no switch any more; the slider is the switch
    // The pack is modelled at the product's own rate: about four hours idling,
    // about thirty-five minutes flat out. In one visit it barely moves — which
    // is the honest answer. It carries over between visits and charges while away.
    var RUN_MIN=2100, RUN_MAX=14400, CHARGE=5400;
    function runtimeAt(p01){ return RUN_MAX*Math.pow(RUN_MIN/RUN_MAX, clamp(p01,0,1)); }
    function loadBatt(){
      try{
        var s=JSON.parse(localStorage.getItem('ottr.sweep.batt')||'null');
        if (s && typeof s.v==='number'){
          var away=Math.max(0,(Date.now()-(s.t||0))/1000);
          batt=clamp(s.v + away/CHARGE, 0, 1);
        }
      }catch(e){}
    }
    var battSaved=0;
    function saveBatt(){
      if (performance.now()-battSaved < 4000) return;
      battSaved=performance.now();
      try{ localStorage.setItem('ottr.sweep.batt', JSON.stringify({v:batt,t:Date.now()})); }catch(e){}
    }
    var pointer={x:-999,y:-999,inside:false,active:false};
    var auto={on:true,x:0,y:0,t:0};
    var lastInput=0;
    var running=false, visible=false, rafId=0, tick=0;
    var sized=false, spawned=false, refill=0, roundN=0;
    var imgs={}, sound=false;
    function rand(a,b){ return a+Math.random()*(b-a); }
    function pick(a){ return a[(Math.random()*a.length)|0]; }
    function clamp(v,a,b){ return v<a?a:(v>b?b:v); }
    function load(key, src, done){
      if (!src){ done && done(); return; }
      var im=new Image();
      im.onload=function(){ imgs[key]=im; done&&done(); };
      im.onerror=function(){ done&&done(); };
      im.src=src;
    }
    /* ---------------- sizing ---------------- */
    function resize(){
      var rect=court.getBoundingClientRect();
      if (rect.width<20 || rect.height<20) return false;   // layout not settled yet
      DPR=Math.min(window.devicePixelRatio||1,2);
      W=Math.max(1,Math.round(rect.width));
      H=Math.max(1,Math.round(rect.height));
      canvas.width=Math.round(W*DPR);
      canvas.height=Math.round(H*DPR);
      ctx.setTransform(DPR,0,0,DPR,0,0);
      floorY=H-Math.round(H*0.11);
      bins=Math.ceil(W/BIN)+1;
      height=new Float32Array(bins);
      auto.x=W*0.5; auto.y=floorY-34;
      sized=true;
      return true;
    }
    var floorY=0, BIN=7, bins=0, height=null;
    function binOf(x){
      var b=(x/BIN)|0;
      return b<0?0:(b>=bins?bins-1:b);
    }
    function settle(p, instant){
      var b=binOf(p.x);
      // Angle of repose: a grain that lands on a steep shoulder rolls down it.
      // Without this a column grows 0.60r per grain against 0.20r for its
      // neighbours, so anything the nozzle herds to one x builds a tower.
      for (var g=0; g<16; g++){
        var hl = b>0       ? height[b-1] : Infinity;
        var hr = b<bins-1  ? height[b+1] : Infinity;
        var lowB = hl<hr ? b-1 : b+1, lowH = hl<hr ? hl : hr;
        if (lowH + p.r*0.75 >= height[b]) break;   // shoulder is within repose
        b = lowB;
      }
      p.x = clamp((b+0.5)*BIN, p.r, W-p.r);
      p.y = floorY-height[b]-p.r;
      if (instant) p.y=floorY-height[b]-p.r;
      p.settled=true; p.bin=b; p.vx=0; p.vy=0;
      height[b]+=p.r*0.60;
      if (b-1>=0)   height[b-1]+=p.r*0.20;
      if (b+1<bins) height[b+1]+=p.r*0.20;
    }
    function unsettle(p){
      if (!p.settled) return;
      p.settled=false;
      var b=p.bin;
      height[b]=Math.max(0,height[b]-p.r*0.60);
      if (b-1>=0)   height[b-1]=Math.max(0,height[b-1]-p.r*0.20);
      if (b+1<bins) height[b+1]=Math.max(0,height[b+1]-p.r*0.20);
    }
    /* ---------------- particles ---------------- */
    var zones=[];
    function seedZones(){
      zones.length=0;
      var n=3+((Math.random()*3)|0);
      for (var i=0;i<n;i++) zones.push({x:rand(W*0.10,W*0.90), s:rand(W*0.028,W*0.065)});
    }
    function dropX(){
      if (zones.length && Math.random()<0.78){
        var z=zones[(Math.random()*zones.length)|0];
        return clamp(z.x + (Math.random()+Math.random()+Math.random()-1.5)*z.s, W*0.02, W*0.98);
      }
      return rand(W*0.03,W*0.97);
    }
    function spawn(){
      if (!sized) return;
      var s=SCENES[sceneKey];
      parts.length=0; collected=0;
      band.classList.remove('is-clear');
      if (refill){ clearTimeout(refill); refill=0; }
      height=new Float32Array(bins);
      seedZones();
      var n=Math.round(s.n * clamp(W/1040, 0.75, 2.0));
      roundN=n;
      queue.length=0;
      for (var i=0;i<n;i++){
        var pr={
          x:dropX(),
          y:-rand(10,H*0.55),
          px:0, py:0,
          vx:rand(-0.25,0.25),
          vy:rand(0,1.2),
          r:rand(s.r[0],s.r[1]), c:pick(s.colors),
          rot:rand(0,6.2832),
          len:s.kind==='strand'?rand(6,15):0,
          sh:s.kind==='chunk'?[rand(.72,1.25),rand(.72,1.25),rand(.72,1.25),rand(.72,1.25),rand(.72,1.25)]:null,
          settled:false, bin:0, pop:0, acted:0,
          t:1
        };
        queue.push(pr);
      }
      spawned=true;
      syncGauges();
    }
    /* ---------------- nozzle ---------------- */
    var ANG=-0.34;   // nozzle angled down into the floor
    function toolSize(){
      var im=imgs[mode]; if (!im) return null;
      var sp=SPRITE[mode], aspect=im.height/im.width;
      // The floor-level minimum shrinks with the court. In a shallow band a fixed
      // minimum makes a tool taller than the room it works in, and the clamp below
      // then holds the nozzle up where the air never lands.
      var lo=Math.min(sp.min, H*0.42);
      var w=clamp(sp.hf*H/aspect, lo, sp.max);
      w=Math.min(w, W*0.34);              // on a phone the court is narrow, not short
      return { w:w, h:w*aspect };
    }
    // How far the tool's body hangs below the nozzle once ANG is applied. The
    // nozzle stops there: you cannot push a vacuum through the floor, and the
    // handle sinking out of the bottom of the court was the tell.
    function lowestY(){
      var sz=toolSize(); if (!sz) return floorY;
      var sp=SPRITE[mode];
      var body=sz.h*(1-sp.tipF)*Math.cos(ANG);   // how far it hangs below the nozzle
      // Keeping the whole tool inside the court is the nicer picture, but not at the
      // cost of the nozzle floating above the mess: reach wins, and the handle may
      // run past the bottom edge, which the court clips.
      return Math.max(floorY+4, H-body);
    }
    function nozzle(){
      if (pointer.inside) return {x:pointer.x,y:Math.min(pointer.y,lowestY()),live:true};
      if (auto.on)        return {x:auto.x,y:Math.min(auto.y,lowestY()),live:true};
      return {x:-999,y:-999,live:false};
    }
    function stepAuto(){
      auto.t+=0.0062;
      auto.x=W*0.5+Math.cos(auto.t)*W*0.34;
      auto.y=floorY-42-(0.5+0.5*Math.sin(auto.t*1.7))*H*0.16;
    }
    /* ---------------- audio ---------------- */
    var actx=null, osc=null, gMotor=null, gAir=null;
    function initAudio(){
      var AC=window.AudioContext||window.webkitAudioContext;
      if (!AC) return false;
      actx=new AC();
      gMotor=actx.createGain(); gMotor.gain.value=0;
      osc=actx.createOscillator(); osc.type='sawtooth'; osc.frequency.value=110;
      var lp=actx.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=2400;
      osc.connect(lp); lp.connect(gMotor); gMotor.connect(actx.destination); osc.start();
      var buf=actx.createBuffer(1, actx.sampleRate*2, actx.sampleRate);
      var d=buf.getChannelData(0);
      for (var i=0;i<d.length;i++) d[i]=Math.random()*2-1;
      var ns=actx.createBufferSource(); ns.buffer=buf; ns.loop=true;
      var bp=actx.createBiquadFilter(); bp.type='bandpass'; bp.frequency.value=1500; bp.Q.value=0.7;
      gAir=actx.createGain(); gAir.gain.value=0;
      ns.connect(bp); bp.connect(gAir); gAir.connect(actx.destination); ns.start();
      return true;
    }
    function tickAudio(p01){
      if (!actx||!gMotor) return;
      var t=actx.currentTime, on=sound?1:0;
      osc.frequency.setTargetAtTime(95+p01*740, t, 0.08);
      gMotor.gain.setTargetAtTime(on*p01*0.032, t, 0.10);
      gAir.gain.setTargetAtTime(on*p01*0.018, t, 0.10);
    }
    sndEl.addEventListener('click', function(){
      if (!actx && !initAudio()) return;
      if (actx.state==='suspended') actx.resume();
      sound=!sound;
      sndEl.setAttribute('aria-pressed', String(sound));
      sndEl.innerHTML = sound ? SND_ON : SND_OFF;
    });
    /* ---------------- gauges ---------------- */
    function syncGauges(){
      var bp=Math.round(batt*100);
      // The pack still drains and still stops the motor when it is flat; the
      // read-out itself was taken off the band, so this is allowed to be absent.
      if (!battEl || !battFillEl) return;
      battFillEl.style.width=bp+'%';
      battEl.classList.toggle('is-low', batt<=0.25 && batt>0.03);
      battEl.classList.toggle('is-flat', batt<=0.03);
    }
    /* ---------------- physics ---------------- */
    var R_VAC=168, R_BLOW=180, GRAB=36;
    function step(){
      tick++;
      var s=SCENES[sceneKey];
      // debris arrives as a stream once the footer is on screen, so the first
      // thing a visitor sees is something starting to fall
      if (armed && queue.length){
        emit += (reduce?6:1.9);
        while (emit>=1 && queue.length){
          emit--;
          var q=queue.shift();
          q.x=dropX();
          q.y=-rand(6,H*0.5);
          parts.push(q);
        }
      }
      powerNow += (powerTarget-powerNow)*0.055;
      if (Math.abs(powerTarget-powerNow)<0.002) powerNow=powerTarget;
      // a flat pack means the motor will not spin, whatever the dial says
      if (batt<=0.004) flat=true;
      if (flat && batt>0.06) flat=false;
      var eff = (flat || !motorOn) ? 0 : powerNow;
      // brushless current climbs steeply with RPM, so runtime collapses at the top
      if (eff>0.02) batt -= (1/60)/runtimeAt(eff);
      else          batt += (1/60)/CHARGE;
      batt=clamp(batt,0,1);
      saveBatt();
      var n=nozzle();
      var vac = mode==='vac';
      var R=(vac?R_VAC:R_BLOW)*(0.30+0.70*eff);
      var R2=R*R;
      var pull=(vac?3.4:3.4)*eff;
      var changed=false;
      for (var i=parts.length-1;i>=0;i--){
        var p=parts[i];
        p.px=p.x; p.py=p.y;
        if (p.t<1) p.t=Math.min(1,p.t+0.028);
        if (p.pop>0) p.pop-=0.05;
        if (p.acted>0) p.acted-=0.08;
        if (n.live && eff>0.01 && p.t>0.55){
          var dx=n.x-p.x, dy=n.y-p.y, d2=dx*dx+dy*dy;
          if (d2<R2){
            p.acted=1;
            var d=Math.sqrt(d2)||0.001;
            var f=(1-d/R); f=f*f;
            if (vac){
              if (d<GRAB){
                unsettle(p);
                collected++;
                changed=true;
                if (auto.on && !pointer.inside){
                  p.x=dropX(); p.y=-rand(10,H*0.7);
                  p.vx=rand(-0.25,0.25); p.vy=rand(0,1.2); p.t=0; p.settled=false;
                } else {
                  parts.splice(i,1);
                }
                continue;
              } else {
                unsettle(p);
                p.vx+=(dx/d)*f*pull;
                p.vy+=(dy/d)*f*pull;
              }
            } else {
              unsettle(p);
              p.vx-=(dx/d)*f*pull;
              p.vy-=(dy/d)*f*pull-f*0.9;
            }
            if (s.kind==='strand') p.rot+=f*0.22;
          }
        }
        if (p.settled){
          // support pulled out from under it (vacuumed from inside a heap):
          // it is now floating above its own column, so let it fall again
          if (p.y < floorY-height[p.bin]-p.r*2.6) unsettle(p);
        }
        if (!p.settled){
          p.vy += s.g;
          p.x += p.vx; p.y += p.vy;
          p.vx *= s.drag; p.vy *= 0.995;
          if (s.kind==='strand') p.rot += p.vx*0.05;
          if (p.x<p.r){ p.x=p.r; p.vx*=-0.4; }
          if (p.x>W-p.r){ p.x=W-p.r; p.vx*=-0.4; }
          if (p.y<-H*2) p.y=-H*2;
          var surface=floorY-height[binOf(p.x)]-p.r;
          if (p.y>=surface){
            if (s.bounce>0.05 && p.vy>1.5){
              p.y=surface; p.vy*=-s.bounce; p.vx*=0.7;
            } else {
              p.y=surface; settle(p,false);
            }
          }
        }
      }
      rpmEl.textContent=Math.round(eff*MAX_RPM).toLocaleString('en-IN');
      if (tick%10===0) syncGauges();
      tickAudio(eff);
      // "clear" has to tolerate a straggler parked somewhere unreachable, or one
      // stubborn piece deadlocks the refill for good
      if (spawned && armed && !queue.length && parts.length <= Math.max(2, Math.round(roundN*0.03))){
        band.classList.add('is-clear');
        // a moment to enjoy it, then a fresh mess — the point is to keep playing
        if (!refill){ refill=setTimeout(function(){ refill=0; spawn(); }, 1900); }
      }
    }
    /* ---------------- drawing ---------------- */
    function drawSurface(){
      ctx.fillStyle=BG;
      ctx.fillRect(0,0,W,H);
      // one soft light from above, so the field has depth instead of being flat black
      var g=ctx.createRadialGradient(W*0.5,-H*0.15,0,W*0.5,-H*0.15,H*1.5);
      g.addColorStop(0,'rgba(190,215,245,0.055)');
      g.addColorStop(1,'rgba(190,215,245,0)');
      ctx.fillStyle=g;
      ctx.fillRect(0,0,W,H);
      // where wall meets floor: the wall darkens into the corner, the floor catches
      // light and runs away from you. That junction is what makes it read as a room.
      var w=ctx.createLinearGradient(0,floorY-76,0,floorY);
      w.addColorStop(0,'rgba(0,0,0,0)');
      w.addColorStop(1,'rgba(0,0,0,0.32)');
      ctx.fillStyle=w;
      ctx.fillRect(0,floorY-76,W,76);
      var f=ctx.createLinearGradient(0,floorY,0,H);
      f.addColorStop(0,'rgba(255,255,255,0.11)');
      f.addColorStop(0.35,'rgba(255,255,255,0.05)');
      f.addColorStop(1,'rgba(255,255,255,0.016)');
      ctx.fillStyle=f;
      ctx.fillRect(0,floorY,W,H-floorY);
      // skirting: a bright top edge sitting on a dark under-shadow
      ctx.lineWidth=1;
      ctx.strokeStyle='rgba(255,255,255,0.24)';
      ctx.beginPath(); ctx.moveTo(0,floorY+0.5); ctx.lineTo(W,floorY+0.5); ctx.stroke();
      ctx.strokeStyle='rgba(0,0,0,0.30)';
      ctx.beginPath(); ctx.moveTo(0,floorY+1.5); ctx.lineTo(W,floorY+1.5); ctx.stroke();
    }
    function drawParticles(){
      var s=SCENES[sceneKey];
      for (var i=0;i<parts.length;i++){
        var p=parts[i];
        if (p.t<=0) continue;
        var t=p.t;
        var scale = t<1 ? (1+(1-t)*2.4) : 1;
        var alpha = t<1 ? Math.min(1,t*1.8) : 1;
        var lift  = t<1 ? (1-t)*10 : 0;
        var rr=p.r*scale;
        // streak, so fast debris reads as moving rather than teleporting
        var sp=Math.abs(p.vx)+Math.abs(p.vy);
        if (sp>2.2 && p.acted>0.15){
          ctx.globalAlpha=alpha*0.35;
          ctx.strokeStyle=p.c; ctx.lineWidth=rr*1.3; ctx.lineCap='round';
          ctx.beginPath(); ctx.moveTo(p.px,p.py); ctx.lineTo(p.x,p.y); ctx.stroke();
        }
        ctx.globalAlpha=alpha*0.26;
        ctx.fillStyle='#000';
        ctx.beginPath();
        ctx.ellipse(p.x+1.5+lift, p.y+2+lift, rr*1.15, rr*0.9, 0, 0, 6.2832);
        ctx.fill();
        ctx.globalAlpha=alpha;
        ctx.fillStyle=p.c;
        if (s.kind==='strand'){
          ctx.strokeStyle=p.c; ctx.lineWidth=rr; ctx.lineCap='round';
          var ax=Math.cos(p.rot)*p.len*0.5*scale, ay=Math.sin(p.rot)*p.len*0.5*scale;
          ctx.beginPath(); ctx.moveTo(p.x-ax,p.y-ay); ctx.lineTo(p.x+ax,p.y+ay); ctx.stroke();
        } else if (s.kind==='chunk'){
          ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.rot);
          ctx.beginPath();
          for (var k=0;k<5;k++){
            var a=k*1.2566, rad=rr*p.sh[k];
            if (k) ctx.lineTo(Math.cos(a)*rad, Math.sin(a)*rad);
            else   ctx.moveTo(Math.cos(a)*rad, Math.sin(a)*rad);
          }
          ctx.closePath(); ctx.fill(); ctx.restore();
        } else {
          ctx.beginPath(); ctx.arc(p.x,p.y,rr,0,6.2832); ctx.fill();
        }
        if (p.pop>0){
          ctx.globalAlpha=p.pop*0.6;
          ctx.strokeStyle='rgba(150,196,255,0.9)';
          ctx.lineWidth=1.5;
          ctx.beginPath(); ctx.arc(p.x,p.y,rr+3.2+(1-p.pop)*11,0,6.2832); ctx.stroke();
        }
      }
      ctx.globalAlpha=1;
    }
    function drawAirflow(n, eff){
      if (eff<0.03) return;
      var vac=mode==='vac';
      var R=(vac?R_VAC:R_BLOW)*(0.30+0.70*eff);
      var pulse=(tick%54)/54;
      ctx.save(); ctx.translate(n.x,n.y);
      for (var k=0;k<3;k++){
        var t=(pulse+k/3)%1;
        var rad=vac?R*(1-t):R*t;
        var al=(vac?t:1-t)*0.26*eff;
        ctx.beginPath();
        ctx.strokeStyle='rgba(150,196,255,'+al.toFixed(3)+')';
        ctx.lineWidth=1.5;
        ctx.arc(0,0,Math.max(2,rad),0,6.2832);
        ctx.stroke();
      }
      ctx.restore();
    }
    function drawSweep(n, eff){
      var im=imgs[mode];
      if (!im) return;
      var sp=SPRITE[mode];
      var sz=toolSize(); if (!sz) return;
      var SW=sz.w, SH=sz.h, oy=-SH*sp.tipF;
      // 130,000 RPM in the hand is not still
      var jx=0, jy=0;
      if (!reduce && eff>0.05){ jx=(Math.random()-0.5)*eff*1.9; jy=(Math.random()-0.5)*eff*1.9; }
      // contact shadow on the floor, under where the nozzle is pointing
      var drop=clamp((floorY-n.y)/220, 0, 1);
      ctx.save();
      ctx.globalAlpha=0.42*(1-drop*0.65);
      var sg=ctx.createRadialGradient(n.x+26, floorY+3, 0, n.x+26, floorY+3, 96);
      sg.addColorStop(0,'rgba(0,0,0,0.85)');
      sg.addColorStop(1,'rgba(0,0,0,0)');
      ctx.fillStyle=sg;
      ctx.beginPath();
      ctx.ellipse(n.x+26, floorY+3, 96, 15, 0, 0, 6.2832);
      ctx.fill();
      ctx.restore();
      // the floor is a surface, so it gives something back
      if (n.y < floorY){
        ctx.save();
        ctx.beginPath(); ctx.rect(0, floorY, W, H-floorY); ctx.clip();
        ctx.globalAlpha=0.13;
        ctx.translate(n.x+jx, 2*floorY-(n.y+jy));
        ctx.scale(1,-1);
        ctx.rotate(ANG);
        ctx.drawImage(im, 0, oy, SW, SH);
        ctx.restore();
      }
      ctx.save();
      ctx.translate(n.x+jx, n.y+jy);
      ctx.rotate(ANG);
      ctx.globalAlpha=1;
      ctx.drawImage(im, 0, oy, SW, SH);
      ctx.restore();
    }
    function draw(){
      drawSurface();
      drawParticles();
      var n=nozzle();
      if (n.live){
        var eff=(flat||!motorOn)?0:powerNow;
        if (!reduce) drawAirflow(n, eff);
        drawSweep(n, eff);
      }
    }
    /* ---------------- loop ---------------- */
    function frame(){
      rafId=0;
      if (!running) return;
      if (auto.on && !pointer.inside) stepAuto();
      step(); draw();
      rafId=requestAnimationFrame(frame);
    }
    function play(){
      if (running||!visible||!sized||!spawned||document.hidden) return;
      running=true;
      if (!rafId) rafId=requestAnimationFrame(frame);
    }
    function pause(){
      running=false;
      if (rafId){ cancelAnimationFrame(rafId); rafId=0; }
      if (actx && actx.state==='running') actx.suspend();
    }
    /* ---------------- input ---------------- */
    function toLocal(e){
      var r=canvas.getBoundingClientRect();
      return {x:e.clientX-r.left, y:e.clientY-r.top};
    }
    function takeOver(){
      if (auto.on){ auto.on=false; collected=0; }
      lastInput=performance.now();
    }
    canvas.addEventListener('pointermove', function(e){
      if (locked()) return;
      var p=toLocal(e);
      pointer.x=p.x; pointer.y=p.y;
      pointer.inside=(e.pointerType==='touch')?pointer.active:true;
      takeOver();
    }, {passive:true});
    canvas.addEventListener('pointerdown', function(e){
      if (locked()) return;
      pointer.active=true;
      var p=toLocal(e);
      pointer.x=p.x; pointer.y=p.y; pointer.inside=true;
      takeOver();
    });
    window.addEventListener('pointerup', function(){
      pointer.active=false;
      if (matchMedia('(pointer: coarse)').matches) pointer.inside=false;
    });
    canvas.addEventListener('pointerleave', function(){ pointer.inside=false; });
    // On a phone the canvas fills the screen, so it must not swallow a scroll.
    // It stays inert to touch until you opt in, and gives you a way back out.
    var gateEl=root.querySelector('[data-sf="gate"]');
    var releaseEl=root.querySelector('[data-sf="release"]');
    // The court opens closed. People were handed this and could not tell it was a
    // game, so nothing answers the pointer until you say you are playing — and the
    // moment you do, the three control groups introduce themselves for five seconds.
    function locked(){ return !band.classList.contains('is-playing'); }
    var coachT=0;
    function coach(on){
      if (coachT){ clearTimeout(coachT); coachT=0; }
      if (on){
        band.classList.add('is-coaching');
        coachT=setTimeout(function(){ band.classList.remove('is-coaching'); coachT=0; }, 5200);
      } else {
        band.classList.remove('is-coaching');
      }
    }
    gateEl.addEventListener('click', function(){
      if (!locked()) return;
      band.classList.add('is-playing');
      coach(true);
      play();
    });
    releaseEl.addEventListener('click', function(){
      band.classList.remove('is-playing');
      coach(false);
      pointer.inside=false; pointer.active=false;
    });
    setInterval(function(){
      if (!auto.on && !pointer.inside && performance.now()-lastInput>6500) auto.on=true;
    }, 1000);
    Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-scene'), function(btn){
      btn.addEventListener('click', function(){
        sceneKey=btn.getAttribute('data-scene');
        Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-scene'), function(b){
          b.setAttribute('aria-pressed', String(b===btn));
        });
        spawn(); announce(); play();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-mode'), function(btn){
      btn.addEventListener('click', function(){
        mode=btn.getAttribute('data-mode');
        Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-mode'), function(b){
          b.setAttribute('aria-pressed', String(b===btn));
        });
      });
    });
    function setPower(v, fromKey){
      v=clamp(v,0,1);
      powerTarget=v;
      powerEl.value=String(Math.round(v*100));
      if (v>0.005){ lastPower=v; }
    }
    powerEl.addEventListener('input', function(){
      setPower((parseInt(powerEl.value,10)||0)/100);
    });
    // R winds it up, E winds it down, M is the sound. There is no on/off switch:
    // the slider at zero is already off, and a toggle on top of it was one control
    // too many for a band this shallow.
    function onKey(e){
      if (e.metaKey||e.ctrlKey||e.altKey) return;
      if (locked()) return;          // the court is still closed; keys belong to the page
      var el=e.target||{}, tag=el.tagName||'';
      if (tag==='TEXTAREA' || tag==='SELECT' || el.isContentEditable) return;
      if (tag==='INPUT' && el.type!=='range') return;
      var k=e.key.toLowerCase();
      if (k==='r' || k==='e'){
        e.preventDefault();
        setPower(powerTarget + (k==='r'? 0.08 : -0.08), true);
        lastInput=performance.now();
        return;
      }
      if (k==='m'){ e.preventDefault(); sndEl.click(); return; }
    }
    window.addEventListener('keydown', onKey);
    /* ---------------- guards ---------------- */
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        visible=en[0].isIntersecting;
        if (visible){ armed=true; play(); } else pause();
      }, {threshold:0.08}).observe(court);
    } else { visible=true; }
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) pause();
      else { if (actx && sound && actx.state==='suspended') actx.resume(); play(); }
    });
    function relayout(){
      if (!resize()) return;          // resize() reallocates the height map
      if (!spawned){ spawn(); }
      else {
        // keep what is already on the floor; re-seat it against the new width
        for (var i=0;i<parts.length;i++){
          var p=parts[i];
          if (p.x<p.r) p.x=p.r;
          if (p.x>W-p.r) p.x=W-p.r;
          if (p.settled){ p.settled=false; settle(p,true); }
        }
      }
      draw(); play();
    }
    if ('ResizeObserver' in window) new ResizeObserver(relayout).observe(court);
    var rt=0;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt=setTimeout(relayout,140); });
    window.addEventListener('load', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout).catch(function(){});
    /* ---------------- boot ---------------- */
    function start(state){
      if (state && state.scene && SCENES[state.scene]) sceneKey=state.scene;
      if (state && (state.mode==='blow'||state.mode==='vac')) mode=state.mode;
      if (state && typeof state.power==='number'){
        powerTarget=state.power;
        powerEl.value=String(Math.round(state.power*100));
      } else {
        powerTarget=(parseInt(powerEl.value,10)||0)/100;
      }
      Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-scene'), function(b){
        b.setAttribute('aria-pressed', String(b.getAttribute('data-scene')===sceneKey));
      });
      Array.prototype.forEach.call(root.querySelectorAll('.ottr-sf-mode'), function(b){
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mode')===mode));
      });
      visible=true; spawned=false;
      loadBatt();
      syncGauges();
      var keys=['vac','blow'], pending=keys.length;
      function ready(){ if (--pending<=0) relayout(); }
      for (var i=0;i<keys.length;i++) load(keys[i], ASSETS[keys[i]], ready);
      relayout();
      var tries=0;
      var poll=setInterval(function(){
        if (sized && spawned){ clearInterval(poll); return; }
        relayout();
        if (++tries>40) clearInterval(poll);
      }, 120);
    }
    start({});
  })();
  }
  function boot(scope){
    var els = (scope || document).querySelectorAll('.ottr-sf');
    for (var i=0;i<els.length;i++) initSweepFloor(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ boot(); });
  else boot();
  // Tinker hydrates sections after first paint, and the theme editor reloads them
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  setTimeout(function(){ boot(); }, 400);
  setTimeout(function(){ boot(); }, 1600);
})();